module.exports = __webpack_public_path__ + "img/19.c13d41d5.jpg";